import { ItemType } from "../../../models/ViewModels/RecordCatalogViewModel";
import { RecordFertilityType } from "../../../models/ViewModels/RecordViewModel";

const RecordFertility = ({
  item,
  catalogs,
  onItemChange, // Add a prop to handle item changes
}: {
  item?: RecordFertilityType;
  catalogs?: Array<ItemType<number>>;
  onItemChange: (updatedItem: RecordFertilityType) => void; // A function to handle item changes
}) => {
  function onCheck(n) {
    const itemId = n.id;

    // Check if the item is already in the value array
    if (!item?.value?.includes(itemId)) {
      // If not, add it to the array
      const updatedValue = [...(item?.value || []), itemId];
      const updatedItem = {
        ...item,
        value: updatedValue,
      };

      // Call the prop function to update the parent component
      onItemChange(updatedItem);
    } else {
      // If it's already in the array, remove it
      const updatedValue = item?.value?.filter((id) => id !== itemId) || [];
      const updatedItem = {
        ...item,
        value: updatedValue,
      };

      // Call the prop function to update the parent component
      onItemChange(updatedItem);
    }
  }

  return (
    <>
      <div className="mr-3 mb-2">
        <label className="text-secondary">نمایش در پرونده</label>
        <input
          type="checkbox"
          className="m-1.5"
          checked={item?.isAbstract!}
          onChange={() =>
            onItemChange({
              ...item,
              isAbstract: !item?.isAbstract!,
              value: item?.value!,
            })
          }
        ></input>
        <br />
      </div>
      <div className="container mx-auto p-4 flex flex-wrap justify-start ">
        {catalogs?.map((n, i) => (
          <div
            className="w-full flex-col sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/5 mb-4 p-2"
            key={n.id}
          >
            <label className="flex items-center">
              <input
                type="checkbox"
                className="mr-2 ml-2"
                name={n.title}
                value={n.id}
                checked={item?.value?.includes(n.id)}
                onChange={() => onCheck(n)}
              />
              {n.title}
            </label>           
          </div>
        ))}
      </div>
    </>
  );
};

export default RecordFertility;
